module.exports = __webpack_public_path__ + "images/category_lp/audio_instrument/new/mainView-pc_0bd80051709e21317ee0e6254bb1187a.png";